import { FC, ReactElement } from 'react';

import { StyledChartTooltip, TooltipPoligon, TooltipStyled } from './ChartTooltip.styles';
import { ChartTooltipProps } from './ChartTooltip.types';

const ChartTooltip: FC<ChartTooltipProps> = ({ active, children, innerRef, poligonPosition }): ReactElement | null => {
  if (active && children) {
    return (
      <StyledChartTooltip ref={innerRef} css={{ alignItems: poligonPosition ?? 'center' }}>
        <TooltipStyled>{children}</TooltipStyled>
        <TooltipPoligon />
      </StyledChartTooltip>
    );
  }

  return null;
};

export default ChartTooltip;
